import { render, staticRenderFns } from "./InvRL.vue?vue&type=template&id=3c2489c6"
import script from "./InvRL.vue?vue&type=script&lang=js"
export * from "./InvRL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports